export const levenshteinDistanceWithin = (a, b, max, { transpositions = false } = {}) => {
  if (max == null || max < 0) return null
  const al = a.length
  const bl = b.length
  if (Math.abs(al - bl) > max) return null
  if (al === 0) return bl <= max ? bl : null
  if (bl === 0) return al <= max ? al : null

  let prev = Array.from({ length: bl + 1 }, (_, j) => j)
  let cur = new Array(bl + 1).fill(Infinity)
  let prevPrev = transpositions ? new Array(bl + 1).fill(Infinity) : null

  for (let i = 1; i <= al; i++) {
    cur[0] = i
    const from = Math.max(1, i - max)
    const to = Math.min(bl, i + max)

    for (let j = 1; j < from; j++) cur[j] = Infinity
    for (let j = from; j <= to; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost)
      if (transpositions && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        cur[j] = Math.min(cur[j], prevPrev[j - 2] + 1)
      }
    }
    for (let j = to + 1; j <= bl; j++) cur[j] = Infinity

    const tmp = transpositions ? prevPrev : prev
    prevPrev = prev
    prev = cur
    cur = tmp
  }

  return prev[bl] <= max ? prev[bl] : null
}
